import { AddIcon, IconEdit, IconDelete } from "../../../components/Icons";
import { StyledFlexDiv } from "../../../styles/MainStyles";
import ModalReportStyles from "../../../styles/pages/Summaries/ModalReportStyles";
import {
    IFilter,
    IFilterType,
} from "../../../context/interfaces/IFilterDataContext";
import { useFilterData } from "../../../context/TachContext/FilterDataContext";

const { StyledModalAction, StyledIconModalButton } = ModalReportStyles;

interface IButtonFilterTach {
    text: string;
    referenceKey: string;
    disabled: boolean;
    hasContent: boolean;
    isGenerate: boolean;
}

const ButtonFilterTach: React.FC<IButtonFilterTach> = ({
    text,
    referenceKey,
    disabled,
    hasContent,
    isGenerate,
}) => {
    const {
        filterGenerate,
        setFilterGenerate,
        filterPage,
        setFilterPage,
        setModalFilterOptions,
        setModalDataFilter,
    } = useFilterData();

    const filter: IFilter = isGenerate ? filterGenerate : filterPage;

    const handleSetFilter = (newFilter: IFilter) => {
        if (isGenerate) {
            setFilterGenerate(newFilter);
        } else {
            setFilterPage(newFilter);
        }
    };

    const handleOpenModal = () => {
        const newFilter = {
            ...filter,
            openModal: true,
        };
        setModalDataFilter(isGenerate, newFilter);
    };

    const handleIncludeItems = () => {
        setModalFilterOptions({
            key: referenceKey,
            tempSelectedValue: [],
        });
        handleOpenModal();
    };

    const handleEditItems = () => {
        setModalFilterOptions({
            key: referenceKey,
            tempSelectedValue: [
                ...(filter[referenceKey] as IFilterType).selectedValue,
            ],
        });
        handleOpenModal();
    };

    const handleDeleteItems = () => {
        let removedTypes;

        if (referenceKey === "campus") {
            removedTypes = {
                school: {
                    list: [],
                    selectedValue: [],
                },
                modality: {
                    list: [],
                    selectedValue: [],
                },
                course: {
                    list: [],
                    selectedValue: [],
                },
                professor: {
                    list: [],
                    selectedValue: [],
                },
            };
        }

        if (referenceKey === "school") {
            removedTypes = {
                modality: {
                    list: [],
                    selectedValue: [],
                },
                course: {
                    list: [],
                    selectedValue: [],
                },
                professor: {
                    list: [],
                    selectedValue: [],
                },
            };
        }

        if (referenceKey === "modality") {
            removedTypes = {
                course: {
                    list: [],
                    selectedValue: [],
                },
                professor: {
                    list: [],
                    selectedValue: [],
                },
            };
        }

        if (referenceKey === "course") {
            removedTypes = {
                professor: {
                    list: [],
                    selectedValue: [],
                },
            };
        }

        const newFilter: IFilter = {
            ...filter,
            ...removedTypes,
            [referenceKey]: {
                ...(filter[referenceKey] as IFilterType),
                selectedValue: [],
            },
        };

        handleSetFilter(newFilter);
    };

    return hasContent ? (
        <div>
            <StyledIconModalButton onClick={() => handleEditItems()}>
                <StyledFlexDiv>
                    <StyledModalAction>Editar</StyledModalAction>
                    <IconEdit style={{ margin: "2px 20px 0 0" }} />
                </StyledFlexDiv>
            </StyledIconModalButton>
            <StyledIconModalButton onClick={() => handleDeleteItems()}>
                <StyledFlexDiv>
                    <StyledModalAction>Excluir</StyledModalAction>
                    <IconDelete style={{ marginTop: "2px" }} />
                </StyledFlexDiv>
            </StyledIconModalButton>
        </div>
    ) : (
        <div>
            <StyledIconModalButton
                onClick={() => handleIncludeItems()}
                border="1px solid #8a0538"
                disabled={disabled}
            >
                <StyledFlexDiv>
                    <AddIcon style={{ marginTop: "2px" }} />
                    <StyledModalAction>{`Incluir ${text}`}</StyledModalAction>
                </StyledFlexDiv>
            </StyledIconModalButton>
        </div>
    );
};

export default ButtonFilterTach;
